import { render, staticRenderFns } from "./target-decomposition.vue?vue&type=template&id=3d5ac950&scoped=true&"
import script from "./target-decomposition.vue?vue&type=script&lang=js&"
export * from "./target-decomposition.vue?vue&type=script&lang=js&"
import style0 from "./target-decomposition.vue?vue&type=style&index=0&id=3d5ac950&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ac950",
  null
  
)

export default component.exports